/**
 * @fileoverview Zod schema for Task entities (Supabase rows/DTOs).
 * @description Minimal stable core with passthrough to tolerate extra columns.
 */

import { z } from 'zod';

export const TaskSchema = z
  .object({
    id: z.string(),
    user_id: z.string(),
    title: z.string().min(1),
    description: z.string().nullable().optional(),
    is_completed: z.boolean().optional(),
    due_date: z.string().nullable().optional(),
    goal_id: z.string().nullable().optional(),
    created_at: z.string().optional(),
    updated_at: z.string().optional(),
    must_do: z.boolean().optional(),
    // Calendar scheduling fields
    start_time: z.string().nullable().optional(),
    end_time: z.string().nullable().optional(),
    is_all_day: z.boolean().optional(),
    all_day_date: z.string().nullable().optional(),
    estimated_duration_minutes: z.number().nullable().optional(),
  })
  .passthrough();

export type Task = z.infer<typeof TaskSchema>;

export function parseTask(input: unknown): Task {
  return TaskSchema.parse(input);
}

export const TaskArraySchema = z.array(TaskSchema);
export type TaskArray = z.infer<typeof TaskArraySchema>;
